import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// If any API call returns 402 (billing required / paused), send the user to /billing.
const BILLING_ENABLED = String(process.env.REACT_APP_BILLING_ENABLED || "true").toLowerCase() !== "false";
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (BILLING_ENABLED && err?.response?.status === 402 && typeof window !== "undefined") {
      const path = window.location.pathname;
      if (!path.startsWith("/billing")) {
        window.location.href = "/billing";
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
